import { observable, action, reaction,toJS, makeObservable } from 'mobx';

class communicatorStore {
  messages_list=[];
  subscribers=[];

  par=null;
  constructor(par) {
    makeObservable(this,{
      messages_list:observable,
    });
    this.par=par;
    reaction(()=>{
      return this.messages_list.length;
    },(len)=>{
      if(len) {
        const mess = this.messages_list[len - 1];
        let was = false;
        if (mess.type == 'input') {
          if (mess.command === 'update_row') {
            this.par.dataStore.updateRow(mess.data);
          }
          if (mess.command === 'refresh_table') {
            this.par.dataStore.refreshData();
          }
          if (mess.command === 'set_simple_filter') {
            this.par.searchStore.setSimpleFilter(mess.filter);
          }
          if (mess.command === 'unselect_all') {
            this.par.selectStore.unselectAll();
          }
          if (mess.command === 'drag_manual') {
            if (mess.data) {
              console.log("DRAG MANUAL!");
              this.par.dragStore.drag_manual_enabled = true;
              this.par.dragStore.drag_manual_data = mess.data;
            } else {
              this.par.dragStore.drag_manual_enabled = false
              this.par.dragStore.drag_manual_data = {};
            }
          }
          if (mess.command === 'section_selected') {
            if (this.par.treeStore.selected_section != mess.section_id) {
              if(mess.section_id == 'all' || mess.section_id == 'root') {
                this.par.treeStore.selected_section = mess.section_id;
              } else {
                this.par.searchStore.selectTree({id: mess.section_id});
              }
            }
            // this.par.treeStore.selected_section = mess.section_id;
            was = true;
          }

          if (was) {
            this.messages_list.splice(len - 1, 1);
          }
        }
      }
    });
  }
  subscribe(func) {
    this.subscribers.push(func);
  }
  pushMessage(ob) {
    this.messages_list.push(ob);
    for(let i in this.subscribers) {
      this.subscribers[i](ob, toJS(this.messages_list));
    }
  }
}

/*decorate(communicatorStore,{
  messages_list:observable,
});*/

export default communicatorStore;
